var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { isValidElement } from 'react';
import styled, { css, withTheme } from 'styled-components';
import { string, node, shape, oneOfType, func } from 'prop-types';
import Text from '../../../Text';
import theme from '../../../Theme/helpers/themeReader';
var _theme$components = theme.components,
    card = _theme$components.card,
    cardweb = _theme$components.cardweb;
var truncateStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var List = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: ", "px 0 0;\n  padding: 0;\n\n  list-style: none;\n"])), cardweb.plan.list.margin.top);
var IconWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-right: ", "px;\n"])), cardweb.plan.list.item.icon.margin.right);
var Item = styled.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  :not(:last-child) {\n    margin-bottom: ", "px;\n  }\n"])), card.plan.list.item.margin.bottom);
var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  min-width: 0;\n  align-items: center;\n\n  svg {\n    flex-shrink: 0;\n  }\n"])));
var ItemText = styled(Text.Small)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n\n  color: ", ";\n\n  ", "\n"])), card.plan.list.item.font.color, truncateStyle);
var Button = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 0;\n  margin-top: ", "px;\n\n  width: 100%;\n\n  letter-spacing: normal;\n\n  background-color: transparent;\n  border: none;\n\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  color: ", ";\n\n  cursor: pointer;\n  text-decoration: none;\n  text-align: left;\n  outline: none;\n\n  ", "\n"])), card.plan.list.button.margin.top, theme.baseFont.family, card.plan.list.button.font.size, card.plan.list.button.font.weight, card.plan.list.button.font.color, truncateStyle);
var ListItem = withTheme(function (_ref) {
  var text = _ref.text,
      Icon = _ref.icon,
      buttonProps = _ref.buttonProps,
      yogaTheme = _ref.theme;
  return /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Wrapper, null, Icon && /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/isValidElement(Icon) ? Icon : /*#__PURE__*/React.createElement(Icon, {
    width: 16,
    height: 16,
    fill: yogaTheme.yoga.colors.text.primary
  })), /*#__PURE__*/React.createElement(ItemText, {
    as: "span"
  }, text)), Boolean(Object.keys(buttonProps).length) && /*#__PURE__*/React.createElement(Button, buttonProps));
});
List.displayName = 'PlanCard.List';
ListItem.displayName = 'PlanCard.ListItem';
Button.displayName = 'PlanCard.ListButton';
ListItem.propTypes = {
  text: string.isRequired,

  /** an icon to be displayed on the begin of the item */
  icon: oneOfType([node, func]),

  /** if provided displays a button below the item text. It accepts all button
   * element props */
  buttonProps: shape({})
};
ListItem.defaultProps = {
  icon: undefined,
  buttonProps: {}
};
export { List, ListItem };